var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6465 14.5V11.875C19.6465 10.011 18.1354 8.5 16.2715 8.5H14.7715C14.1502 8.5 13.6465 7.99632 13.6465 7.375V5.875C13.6465 4.01104 12.1354 2.5 10.2715 2.5H8.39648M13.6276 15.9812L15.1465 17.5M10.6465 2.5H5.77148C5.15016 2.5 4.64648 3.00368 4.64648 3.625V20.125C4.64648 20.7463 5.15016 21.25 5.77148 21.25H18.5215C19.1428 21.25 19.6465 20.7463 19.6465 20.125V11.5C19.6465 6.52944 15.617 2.5 10.6465 2.5ZM14.3965 14.125C14.3965 15.5747 13.2212 16.75 11.7715 16.75C10.3217 16.75 9.14648 15.5747 9.14648 14.125C9.14648 12.6753 10.3217 11.5 11.7715 11.5C13.2212 11.5 14.3965 12.6753 14.3965 14.125Z",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindIcon);
export default __webpack_public_path__ + "static/media/find-icon.7cf9ea1ccf6e98680c5c8d6546a744e6.svg";
export { ForwardRef as ReactComponent };